import { autocompletePanel_MPG } from './autocomplete/brand-settings/mpg';
import { autocompletePanel_MMO } from './autocomplete/brand-settings/mmo';
import { autocompletePanel_MA } from './autocomplete/brand-settings/ma';


// Maps raw Algolia `size` facet values to a customer-facing group label.
// Any raw value NOT listed here is shown as its own ungrouped option
// (its raw value doubles as both key and label).
export const SIZE_GROUP_MAP = {
  'XS': 'XS',
  'S': 'S',
  'M': 'M',
  'L': 'L',
  'XL': 'XL',
  'XXL': 'XXL',
  '2XL': '2XL',
  '3XL': '3XL',
  '1X': '1X',
  '2X': '2X',
  '3X': '3X',
  'One Size': 'One Size',

  '0': 'XS',
  '2': 'XS',
  '4': 'S',
  '6': 'S',
  '8': 'M',
  '10': 'M',
  '12': 'L',
  '14': 'L',
  '16': 'XL',
  '18': 'XXL',

  '30': 'S',
  '31': 'S',
  '32': 'M',
  '33': 'M',
  '34': 'L',
  '35': 'L',
  '36': 'XL',
  '38': 'XXL',

  'XS (28in)': 'XS',
  'S (28in)': 'S',
  'M (28in)': 'M',
  'L (28in)': 'L',
  'XL (28in)': 'XL',

  'XS (30in)': 'XS',
  'S (30in)': 'S',
  'M (30in)': 'M',
  'L (30in)': 'L',
  'XL (30in)': 'XL',
  '2XL (30in)': '2XL',

  'S (32in)': 'S',
  'M (32in)': 'M',
  'L (32in)': 'L',
  'XL (32in)': 'XL',
  '2XL (32in)': '2XL',

  'S (33in)': 'S',
  'M (33in)': 'M',
  'L (33in)': 'L',
  'XL (33in)': 'XL',
  '2XL (33in)': '2XL',

  'S-TALL': 'S',
  'M-TALL': 'M',
  'L-TALL': 'L',
  'XL-TALL': 'XL',
  '2XL-TALL': '2XL',

  'S (35in)': 'S',
  'M (35in)': 'M',
  'L (35in)': 'L',
  'XL (35in)': 'XL',
  '2XL (35in)': '2XL',

  '1': 'One Size',

  '5/6': 'Kids 5/6',
  'XS 5/6': 'Kids 5/6',
  'S (6)': 'Kids 5/6',

  '7/8': 'Kids 7/8',
  'S 7/8': 'Kids 7/8',
  'M (7/8)': 'Kids 7/8',

  '10/12': 'Kids 10/12',
  'M 10/12': 'Kids 10/12',
  'L (10/12)': 'Kids 10/12',

  '14/16': 'Kids 14/16',
  'L 14/16': 'Kids 14/16',
  'XL (14/16)': 'Kids 14/16',

  '18/20': 'Kids 18/20',

};

// Display order for groups in the UI. Anything not listed (grouped or
// ungrouped) falls to the end, sorted alphabetically.
export const SIZE_GROUP_ORDER = [
  'XS',
  'XS/S',
  'S',
  'M',
  'M/L',
  'L',
  'XL',
  'XXL',
  '2XL',
  '1X',
  '3XL',
  '2X',
  '3X',
  'Kids 5/6',
  'Kids 7/8',
  'Kids 10/12',
  'Kids 14/16',
  'Kids 18/20',
  'One Size',
  '30',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '38',
  '40',
  '42',
  '44',
  '46',
  '48',
  '50',
];

export const COLOR_GROUP_ORDER = [
  'White',
  'Black',
  'Brown',
  'Dark Grey',
  'Grey',
  'Silver',
  'Beige',
  'Mauve',
  'Maroon',
  'Red',
  'Orange',
  'Gold',
  'Yellow',
  'Lime',
  'Green',
  'Olive',
  'Navy',
  'Blue',
  'Light Blue',
  'Teal',
  'Purple',
  'Pink',
  'Multi',
];

export const algoliaConfig = {
  mpg: {
    algolia: {
      // Credentials pulled from Vite env vars (VITE_ prefix exposes to client bundle)
      appId: import.meta.env.VITE_ALGOLIA_MPG_APP_ID,
      apiKey: import.meta.env.VITE_ALGOLIA_MPG_API_KEY,
    },

    autocomplete: {
      productHitsPerPage: 12,
      debounceChars: 2,
      debounceMs: 700,

      suggestions: {
        enabled: true,
        hitsPerPage: 4,
        headerText: 'Trending',
      },

      initialProducts: {
        enabled: true,
        filter: 'tags:sortd-bestseller-150weeks',
      },

      carouselResults: {
        enabled: true,
      },

      collectionPageResults: {
        enabled: true,
        hitsPerPage: 4,
        headerText: 'Collections & Pages',
        noResultsText: 'No products found.',
      },
    },

    noResults: {
      didYouMean: {
        enabled: true,
        hitsPerPage: 3,
      },
      bestsellers: {
        enabled: true,
        hitsPerPage: 8,
      },
    },

    facets: {
      attributes: {
        'meta.filter.swatch.fields.name': {
          type: 'swatch',
          label: 'Color',
          disjunctive: true,
          order: COLOR_GROUP_ORDER
        },
        'options.size': {
          type: 'checkbox',
          label: 'Size',
          disjunctive: true,
          groupMap: SIZE_GROUP_MAP,
          order: SIZE_GROUP_ORDER
        },
        'product_type': {
          type: 'checkbox',
          label: 'Category',
          disjunctive: true,
          order: 'alpha'
        },
        'price': {
          type: 'range',
          label: 'Price',
          disjunctive: false
        },
      },
    },

    render: {
      autocomplete: autocompletePanel_MPG,
    },

    /**
     * onOpen — called once on first panel open (see autocomplete.js onStateChange).
     * Fetches initial content hits and returns them for carousel mounting.
     *
     * Only defined for brands that have content to pre-fetch. Brands that don't
     * simply omit this key — autocomplete.js handles the missing case via optional
     * chaining (config.onOpen?.()).
     *
     * @param {object} searchClient — algoliasearch/lite instance
     * @param {object} config — this brand's config object
     * @returns {Promise<Array>} Algolia hit objects
     */
    async onOpen(searchClient, config) {
      if (!config.autocomplete.initialProducts.enabled) return [];

      const { results } = await searchClient.search({
        requests: [{
          indexName: 'shopify_products',
          query: '',
          hitsPerPage: config.autocomplete.productHitsPerPage,
          filters: config.autocomplete.initialProducts.filter,
        }]
      });

      return results[0].hits;
    },
  },



  mmo: {
    algolia: {
      // Credentials pulled from Vite env vars (VITE_ prefix exposes to client bundle)
      appId: import.meta.env.VITE_ALGOLIA_MMO_APP_ID,
      apiKey: import.meta.env.VITE_ALGOLIA_MMO_API_KEY,
    },

    autocomplete: {
      productHitsPerPage: 12,
      debounceChars: 2,
      debounceMs: 700,

      suggestions: {
        enabled: true,
        hitsPerPage: 4,
        headerText: 'Trending',
      },

      initialProducts: {
        enabled: true,
        filter: 'tags:sortd-bestseller-150weeks',
      },

      carouselResults: {
        enabled: true,
      },

      collectionPageResults: {
        enabled: true,
        hitsPerPage: 4,
        headerText: 'Collections & Pages',
        noResultsText: 'No products found.',
      },
    },

    noResults: {
      didYouMean: {
        enabled: true,
        hitsPerPage: 3,
      },
      bestsellers: {
        enabled: true,
        hitsPerPage: 8,
      },
    },

    facets: {
      attributes: {
        'meta.filter.swatch.fields.name': {
          type: 'swatch',
          label: 'Color',
          disjunctive: true,
          order: COLOR_GROUP_ORDER
        },
        'options.size': {
          type: 'checkbox',
          label: 'Size',
          disjunctive: true,
          groupMap: SIZE_GROUP_MAP,
          order: SIZE_GROUP_ORDER
        },
        'product_type': {
          type: 'checkbox',
          label: 'Category',
          disjunctive: true,
          order: 'alpha'
        },
        'price': {
          type: 'range',
          label: 'Price',
          disjunctive: false
        },
        'vendor': {
          type: 'checkbox',
          label: 'Brand',
          disjunctive: true
        },
      },
    },

    render: {
      autocomplete: autocompletePanel_MMO,
    },

    /**
     * onOpen — called once on first panel open (see autocomplete.js onStateChange).
     * Fetches initial content hits and returns them for carousel mounting.
     *
     * Only defined for brands that have content to pre-fetch. Brands that don't
     * simply omit this key — autocomplete.js handles the missing case via optional
     * chaining (config.onOpen?.()).
     *
     * @param {object} searchClient — algoliasearch/lite instance
     * @param {object} config — this brand's config object
     * @returns {Promise<Array>} Algolia hit objects
     */
    async onOpen(searchClient, config) {
      if (!config.autocomplete.initialProducts.enabled) return [];

      const { results } = await searchClient.search({
        requests: [{
          indexName: 'shopify_products',
          query: '',
          hitsPerPage: config.autocomplete.productHitsPerPage,
          filters: config.autocomplete.initialProducts.filter,
        }]
      });

      return results[0].hits;
    },
  },




  ma: {
    algolia: {
      // Credentials pulled from Vite env vars (VITE_ prefix exposes to client bundle)
      appId: import.meta.env.VITE_ALGOLIA_MA_APP_ID,
      apiKey: import.meta.env.VITE_ALGOLIA_MA_API_KEY,
    },

    autocomplete: {
      productHitsPerPage: 12,
      debounceChars: 2,
      debounceMs: 700,

      suggestions: {
        enabled: true,
        hitsPerPage: 4,
        headerText: 'Popular Searches',
      },

      initialProducts: {
        enabled: false,
        filter: '',
      },

      carouselResults: {
        enabled: true,
      },

      collectionPageResults: {
        enabled: true,
        hitsPerPage: 4,
        headerText: 'Collections & Pages',
        noResultsText: 'No products found.',
      },
    },

    noResults: {
      didYouMean: {
        enabled: true,
        hitsPerPage: 3,
      },
      bestsellers: {
        enabled: false,
        hitsPerPage: 8,
      },
    },

    facets: {
      attributes: {
        'meta.filter.swatch.fields.name': {
          type: 'swatch',
          label: 'Color',
          disjunctive: true,
          order: COLOR_GROUP_ORDER
        },
        'options.size': {
          type: 'checkbox',
          label: 'Size',
          disjunctive: true,
          order: SIZE_GROUP_ORDER
        },
        'product_type': {
          type: 'checkbox',
          label: 'Category',
          disjunctive: true,
          order: 'alpha'
        },
        'price': {
          type: 'range',
          label: 'Price',
          disjunctive: false
        },
      },
    },

    render: {
      autocomplete: autocompletePanel_MA,
    },

    /**
     * onOpen — called once on first panel open (see autocomplete.js onStateChange).
     * Fetches initial content hits and returns them for carousel mounting.
     *
     * Only defined for brands that have content to pre-fetch. Brands that don't
     * simply omit this key — autocomplete.js handles the missing case via optional
     * chaining (config.onOpen?.()).
     *
     * @param {object} searchClient — algoliasearch/lite instance
     * @param {object} config — this brand's config object
     * @returns {Promise<Array>} Algolia hit objects
     */
    async onOpen(searchClient, config) {
      if (!config.autocomplete.initialProducts.enabled) return [];

      const { results } = await searchClient.search({
        requests: [{
          indexName: 'shopify_products',
          query: '',
          hitsPerPage: config.autocomplete.productHitsPerPage,
          filters: config.autocomplete.initialProducts.filter,
        }]
      });

      return results[0].hits;
    },
  },
};